import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect, useState } from 'react';

function GoogleRecaptcha({ onChange }) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return isClient ? (
        <ReCAPTCHA
            sitekey={import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY}
            onChange={(value) => onChange(value)}
        />
    ) : null;
}
export default GoogleRecaptcha;
